import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "error-modal p-4"
}
const _hoisted_6 = { class: "error-container" }
const _hoisted_7 = { class: "sub-text" }
const _hoisted_8 = { class: "sub-text" }
const _hoisted_9 = { class: "d-flex justify-content-center mt-3" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "main eligibility-container" }
const _hoisted_12 = { class: "d-flex justify-content-center mt-5" }
const _hoisted_13 = { class: "patient-container mb-3 p-3" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, " Date of Birth", -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, " Medicare Number", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, " Expiration Date:", -1 /* HOISTED */)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, " Gender", -1 /* HOISTED */)
const _hoisted_19 = { class: "medical mb-5 p-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 fw-medium" }, "Medicare Eligibility", -1 /* HOISTED */)
const _hoisted_21 = { class: "medicare-part medicare-container mb-3" }
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "sub-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle text-success me-1" }),
  /*#__PURE__*/_createTextVNode(" Medicare Part A ")
], -1 /* HOISTED */)
const _hoisted_24 = { class: "sub-text" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " This covers most medically necessary hospital, skilled nursing facility, home health and hospice care. ", -1 /* HOISTED */)
const _hoisted_26 = { class: "medicare-part medicare-container" }
const _hoisted_27 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "sub-text" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle text-success me-1" }),
  /*#__PURE__*/_createTextVNode(" Medicare Part B ")
], -1 /* HOISTED */)
const _hoisted_29 = { class: "sub-text" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, " This covers most medically necessary doctors' services, preventive care, durable medical equipment, hospital outpatient services, laboratory tests, x-rays, mental health care, and some home health and ambulance services. ", -1 /* HOISTED */)
const _hoisted_31 = { class: "medicare-part medicare-container-c mt-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "sub-text-part-c" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle me-1" }),
    /*#__PURE__*/_createTextVNode(" Medicare Part C (Advantage Plans) ")
  ])
], -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, " This allows private health insurance companies such as Health Maintenance Organizations (HMO) and Preferred Provider Organizations (PPO)to provide Medicare benefits. These plans offer at least the same benefits as original Medicare (those covered under Parts A and B) but can do so with different rules, costs and coverage restrictions. ", -1 /* HOISTED */)
const _hoisted_34 = { class: "d-flex align-items-end flex-column current-date" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "Effective Date - Term Date", -1 /* HOISTED */)
const _hoisted_36 = { class: "d-flex gap-0 flex-column ms-2 ps-3 details" }
const _hoisted_37 = { class: "current-date mb-0" }
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { class: "mb-0" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, " Plan Number", -1 /* HOISTED */)
const _hoisted_41 = { class: "mb-0" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("strong", null, " Address", -1 /* HOISTED */)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("strong", null, " Phone", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
      : _createCommentVNode("v-if", true),
    (!_ctx.isLoading && _ctx.eligibilityData?.Request_Validation?.yes_no_response_code)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h6", _hoisted_7, "Server Error: " + _toDisplayString(_ctx.eligibilityData?.Request_Validation?.reject_reason_code), 1 /* TEXT */),
            _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.eligibilityData?.Request_Validation?.follow_up_action_code), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-sm",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
            }, "Close")
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (!_ctx.isLoading && !_ctx.eligibilityData?.Request_Validation?.yes_no_response_code)
      ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm me-3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadEligibility()))
              }, "Print"),
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
              }, "Close")
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.eligibilityData?.Subscriber?.first_name) + ", " + _toDisplayString(_ctx.eligibilityData?.Subscriber?.last_name), 1 /* TEXT */),
              _createElementVNode("p", null, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.eligibilityData?.Subscriber?.date), 1 /* TEXT */)
              ]),
              _createElementVNode("p", null, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.eligibilityData?.Subscriber?.identification_code), 1 /* TEXT */)
              ]),
              _createElementVNode("p", null, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_ctx.eligibilityData?.Subscriber?.expiration_date), 1 /* TEXT */)
              ]),
              _createElementVNode("p", null, [
                _hoisted_18,
                _createTextVNode(" " + _toDisplayString(_ctx.eligibilityData?.Subscriber?.gender), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.eligibilityData?.Medicare_Part_A?.date), 1 /* TEXT */)
                ]),
                _hoisted_25
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.eligibilityData?.Medicare_Part_B?.date), 1 /* TEXT */)
                ]),
                _hoisted_30
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("p", null, _toDisplayString(_ctx.eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.date), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.name), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.insurance_type), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_39, [
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(_ctx.eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.reference_id), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", _hoisted_41, [
                    _hoisted_42,
                    _createTextVNode(" " + _toDisplayString(_ctx.eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.address1), 1 /* TEXT */)
                  ]),
                  _createElementVNode("p", null, [
                    _hoisted_43,
                    _createTextVNode(" " + _toDisplayString(_ctx.eligibilityData?.MedicareAdvantages?.medicareAdvantagePayers[0]?.phone), 1 /* TEXT */)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}